import { Trans, useTranslation } from 'react-i18next';
import {
	DataBoxListStatesType,
	useDataBoxActionInfoContext,
} from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { EmptyMessage } from '@gov-nx/ui/web';
import { ListStateContent } from './ListStateContent';

export const DataBoxActionInfoPage = () => {
	const { listState } = useDataBoxActionInfoContext();
	const { t } = useTranslation([PageCode['datove-schranky']]);

	switch (listState) {
		case DataBoxListStatesType.List:
			return <ListStateContent />;

		case DataBoxListStatesType.Search:
			return (
				<div className="px-6 py-4 h-full">
					<div className="flex h-full justify-center items-center">
						<EmptyMessage
							headline={null}
							image="search"
							align="left">
							<p className="text-headline-xs! text-(--text-primary)!">
								{t('info-stranka.vyhledavani.vyhledavani')}
							</p>
							<p className="flex gap-2 items-center font-bold!">
								{t('info-stranka.vyhledavani.podle')}
							</p>
							<ul>
								<li>{t('info-stranka.vyhledavani.predmet')}</li>
								<li>{t('info-stranka.vyhledavani.odesilatel')}</li>
								<li>{t('info-stranka.vyhledavani.schranka')}</li>
								<li>{t('info-stranka.vyhledavani.zprava')}</li>
							</ul>
							<p>
								<Trans
									t={t}
									i18nKey="info-stranka.vyhledavani-slozka"
									components={{ strong: <strong /> }}
								/>
							</p>
						</EmptyMessage>
					</div>
				</div>
			);

		case DataBoxListStatesType.MassArchive:
		case DataBoxListStatesType.SearchMassArchive:
			return (
				<div className="px-6 py-4 h-full">
					<div className="flex h-full justify-center items-center">
						<EmptyMessage
							headline={null}
							image="archive-copy">
							<p className="text-headline-xs! text-(--text-primary)!">
								{t('info-stranka.kopirovani-do-archivu')}
							</p>
							<p>{t('info-stranka.najdete-datovka')}</p>
						</EmptyMessage>
					</div>
				</div>
			);

		case DataBoxListStatesType.MassRemove:
		case DataBoxListStatesType.SearchMassRemove:
			return (
				<div className="px-6 py-4 h-full">
					<div className="flex h-full justify-center items-center">
						<EmptyMessage
							headline={null}
							image="bin">
							<p className="text-headline-xs! text-(--text-primary)!">
								{t('info-stranka.vybrane-smazani')}
							</p>
							<p>{t('info-stranka.automaticke-odstraneni')}</p>
						</EmptyMessage>
					</div>
				</div>
			);

		case DataBoxListStatesType.MassPermanentRemove:
		case DataBoxListStatesType.SearchMassPermanentRemove:
			return (
				<div className="px-6 py-4 h-full">
					<div className="flex h-full justify-center items-center">
						<EmptyMessage
							headline={null}
							image="bin-empty">
							<p className="text-headline-xs! text-(--text-primary)!">
								{t('info-stranka.kos-odstranit')}
							</p>
						</EmptyMessage>
					</div>
				</div>
			);

		case DataBoxListStatesType.MassRestore:
		case DataBoxListStatesType.SearchMassRestore:
			return (
				<div className="px-6 py-4 h-full">
					<div className="flex h-full justify-center items-center">
						<EmptyMessage
							headline={null}
							image="bin-archive">
							<p className="text-headline-xs! text-(--text-primary)!">
								{t('info-stranka.kos-obnovit')}
							</p>
						</EmptyMessage>
					</div>
				</div>
			);
		default:
			return null;
	}
};
